import React from 'react';
import { ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SlidingExternalLinkIconProps {
  className?: string;
  size?: number;
}

export const SlidingExternalLinkIcon: React.FC<SlidingExternalLinkIconProps> = ({
  className,
  size,
}) => {
  return (
    <ExternalLink
      size={size}
      className={cn(
        'h-4 w-4 shrink-0 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5',
        className,
      )}
    />
  );
};
